/*
  SAVED — the shortlist. Browser-only, no account needed.

  Ben, 10 Aug: option 1, across the whole site. Deliberately localStorage rather
  than customer-account backed:
    - it works for guests, which is nearly everyone browsing
    - customer accounts have been the flaky part of this store
    - account sync can layer on later without touching any of this UI
  The trade-off is per-device: save on a phone, it is not on the laptop. That is
  acceptable for a shortlist and is stated on the Saved page rather than hidden.

  Enough of each product is stored to render the Saved page with no fetch —
  otherwise the page needs a round trip per item just to show a title.

  ⚠ Everything is delegated from `document`, so controls that appear after load
  (a grid paginating, a quick-view opening) work without re-binding.
*/
(function () {
  var KEY = 'farrellys_saved';
  var MAX = 200; // a shortlist, not a warehouse — stops localStorage filling up

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      // Private mode, or a full/blocked store. Fail as "nothing saved" rather
      // than throwing — a broken save control must not break the page.
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
      return true;
    } catch (e) {
      return false;
    }
  }

  function has(id) {
    return read().some(function (item) { return String(item.id) === String(id); });
  }

  function toggle(id, payload) {
    var list = read();
    var i = list.findIndex(function (item) { return String(item.id) === String(id); });
    if (i > -1) {
      list.splice(i, 1);
    } else {
      list.unshift(payload || { id: id });
    }
    write(list);
    paint();
    document.dispatchEvent(new CustomEvent('saved:change', { detail: { count: list.length } }));
    return i === -1;
  }

  /* Paint every control and the header count from one source of truth, so a
     product saved from a card also reads "Saved" on its own product page. */
  function paint() {
    var list = read();
    var ids = list.map(function (i) { return String(i.id); });

    document.querySelectorAll('[data-save-id]').forEach(function (el) {
      var on = ids.indexOf(String(el.getAttribute('data-save-id'))) > -1;
      el.classList.toggle('is-saved', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = el.querySelector('[data-save-label]');
      if (label) label.textContent = on ? 'Saved' : 'Save';
      var name = el.getAttribute('data-save-title') || 'this item';
      el.setAttribute('aria-label', (on ? 'Remove ' : 'Save ') + name);
    });

    document.querySelectorAll('[data-saved-count]').forEach(function (el) {
      el.textContent = list.length ? String(list.length) : '';
      el.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-save-id]');
    if (!btn) return;
    /* The card is one big <a>. The control sits OUTSIDE that anchor by design —
       a button inside an anchor is invalid and the click would navigate — but
       stop propagation anyway in case a future card nests it. */
    e.preventDefault();
    e.stopPropagation();
    var id = btn.getAttribute('data-save-id');
    var payload;
    try { payload = JSON.parse(btn.getAttribute('data-save-payload') || '{}'); } catch (err) {
      /* A malformed payload used to be stored as {} — a row with no id, which
         could never be matched, painted or removed. Fall back to the id and the
         title we already have in attributes so the row stays usable. */
      payload = { title: btn.getAttribute('data-save-title') || '' };
    }
    /* Always stamp the id, whatever the payload said. It is the only field the
       rest of the system matches on. */
    payload.id = id;
    toggle(id, payload);
  });

  /* Saved in one tab, reflected in the others. */
  window.addEventListener('storage', function (e) { if (e.key === KEY) paint(); });

  document.addEventListener('DOMContentLoaded', paint);
  if (document.readyState !== 'loading') paint();

  window.FarrellysSaved = { read: read, has: has, toggle: toggle, paint: paint, key: KEY };
})();
